/*
  Footer link lists: on phones they are accordions that start closed, on larger screens they are always open.
  Without JavaScript they simply stay open.
*/
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const sync = () => document.querySelectorAll('.jvf__acc').forEach((el) => { el.open = !phone.matches; });
  sync();
  phone.addEventListener('change', sync);
})();
